import { useEffect, useState } from 'react';

import styles from './Stepper.module.css';

type StepperProps = {
  prevStep: number;
  currentStep: number;
  totalSteps: number;
};

const getPos = (curVal: number, totalVal: number) =>
  `${Math.round((curVal / (totalVal + 1)) * 100)}%`;

export default function Stepper({
  prevStep,
  currentStep,
  totalSteps,
}: StepperProps) {
  const [topPos, setTopPos] = useState(() => getPos(prevStep, totalSteps));
  useEffect(() => {
    setTopPos(getPos(currentStep, totalSteps));
  }, [currentStep, totalSteps]);

  return (
    <div className={styles['stepper-container']} data-testid="stepper-container">
      <span className={styles['stepper-indicator']} style={{ top: topPos }} data-testid="stepper-indicator" />
    </div>
  );
}
